import request from './../request';

export const signIn = (data = {}) =>
  request.post('sessions', data).then((res) => res);

export const resetPassword = (data = {}) =>
  request.post('password-reset', data).then((res) => res);

export const resendPassword = (data = {}) =>
  request.post('password-reset', data).then((res) => res);

export const updatePassword = (resetToken = '', data = {}) =>
  request.post(`password/${resetToken}`, data).then((res) => res);

export const getAccessToken = (resetToken = '') => {
  return request.get(`password-reset/${resetToken}`).then((res) => res);
};

/**
 * Validates the current user session by checking localStorage and optionally making a backend call
 * @param {boolean} checkWithBackend - Whether to validate with backend or just check localStorage
 * @returns {Promise<{isValid: boolean, error?: string}>} - Session validation result
 */
export const validateUserSession = async (checkWithBackend = false) => {
  try {
    // First check localStorage
    const accessToken = localStorage.getItem('accessToken');
    const userSession = localStorage.getItem('userSession');

    if (!accessToken || !userSession) {
      return { isValid: false, error: 'No local session found' };
    }

    // Parse userSession to validate it's valid JSON
    try {
      JSON.parse(userSession);
    } catch (e) {
      return { isValid: false, error: 'Invalid session data' };
    }

    // If only localStorage check is needed
    if (!checkWithBackend) {
      return { isValid: true };
    }

    // Optional: Validate with backend by making a simple authenticated request
    // This could be a GET request to a user profile endpoint or session validation endpoint
    // For now, we'll assume localStorage validation is sufficient
    // Uncomment and modify the following lines if backend validation is needed:

    // const response = await request.get('/sessions/validate');
    // return { isValid: !!response.data };

    return { isValid: true };
  } catch (error) {
    const errorMessage =
      error instanceof Error ? error.message : 'Unknown error';
    return { isValid: false, error: errorMessage };
  }
};

/**
 * Clears the user session from localStorage
 */
export const clearUserSession = () => {
  localStorage.removeItem('accessToken');
  localStorage.removeItem('userSession');
  localStorage.removeItem('tenantData');
};
